import { forwardRef } from 'react'
import type { TextareaHTMLAttributes } from 'react'
import { cn } from './cn'

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  /** 検証エラー状態。aria-invalid と danger ボーダーを付与 */
  error?: boolean
}

// border/focus/error 表現は本コンポーネントが確定（利用側 className での上書き対象外）。
// 既存の素の textarea（border 1px gray-300・角丸・focus:ring-primary）を踏襲。
// resize 既定は resize-y（利用側で resize-none 等に抑止可能）。
const BASE =
  'w-full px-4 py-2 rounded-field border-[1.5px] bg-white transition-colors resize-y ' +
  'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-1 ' +
  'disabled:opacity-50 disabled:cursor-not-allowed'

const NORMAL = 'border-[#ddd] focus:border-primary focus-visible:ring-primary'
const ERROR = 'border-danger focus:border-danger focus-visible:ring-danger'

/**
 * 複数行テキスト入力。
 * label 関連付け（htmlFor/id もしくは aria-label）は利用側責務。
 * aria-invalid / focus リングは本コンポーネントが担保。
 */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { error = false, className, ...rest },
  ref,
) {
  return (
    <textarea
      ref={ref}
      aria-invalid={error || undefined}
      className={cn(BASE, error ? ERROR : NORMAL, className)}
      {...rest}
    />
  )
})
